'use client';

import { RedirectToSignIn, useUser } from '@clerk/nextjs';
import React from 'react';
import { usePathname } from 'next/navigation';
import Loader from '../Loader/Loader';
import { PUBLIC_ROUTES } from '@/config/publicRoutes';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isSignedIn, isLoaded } = useUser();
  const pathname = usePathname();

  // Check if the current route is a public route, including wildcard patterns
  const isPublicRoute = PUBLIC_ROUTES.some((route) => {
    if (route.endsWith('*')) {
      const baseRoute = route.slice(0, -1); // Remove the * at the end
      return pathname?.startsWith(baseRoute);
    }
    return pathname === route;
  });

  if (!isLoaded) {
    return <Loader position={'absolute'} />;
  }

  if (!isSignedIn && !isPublicRoute) {
    return <RedirectToSignIn />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
